import * as React from 'react';
import { Body, Loader } from 'vet-bones/design-system/components';

import styles from 'src/components/dataSourceSelection/selectionPanelContainer.module.scss';

export type SelectionPanelContainerProps = {
  /** Subtitle text displayed below the panel header */
  subtitle: string;
  /** Whether the panel is in a loading state */
  isLoading?: boolean;
  /** Whether the panel has no items to display */
  isEmpty?: boolean;
  /** Message to display when isEmpty is true */
  emptyMessage?: string;
  /** The grid content (cards) to display */
  children: React.ReactNode;
  /** Test ID for the container */
  testId?: string;
  /** If true, children are rendered without the default grid wrapper */
  noGridWrapper?: boolean;
};

export const SelectionPanelContainer: React.VFC<
  SelectionPanelContainerProps
> = ({
  subtitle,
  isLoading = false,
  isEmpty = false,
  emptyMessage,
  children,
  testId,
  noGridWrapper = false,
}) => {
  return (
    <div className={styles.panelContainer} data-testid={testId}>
      <div className={styles.panelHeader}>
        <Body size="md" weight="regular">
          {subtitle}
        </Body>
      </div>

      <div className={styles.panelContent}>
        {isLoading ? (
          <div className={styles.panelLoading}>
            <Loader size={72} />
          </div>
        ) : null}
        {!isLoading && isEmpty ? (
          <div className={styles.panelEmpty}>
            <Body size="md">{emptyMessage}</Body>
          </div>
        ) : null}
        {!isLoading && !isEmpty && noGridWrapper ? children : null}
        {!isLoading && !isEmpty && !noGridWrapper ? (
          <div className={styles.cardsGrid}>{children}</div>
        ) : null}
      </div>
    </div>
  );
};
